import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";

import { TextInput } from "../../../../../common/form";

import validationUtils from "../../../../../../utils/ValidationUtils";
import { FOLLOW_UP_COMMENTS_VALIDATION_RULES } from "./followUpCommentsValidationRules";

class FollowUpsCommentsFields extends React.Component {
  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <Field
          id="value"
          name="value"
          groupClassName="follow-up-comment-field"
          component={TextInput}
          type="textarea"
          componentClass="textarea"
        />
      </form>
    );
  }
}

FollowUpsCommentsFields.propTypes = {
  validation: PropTypes.object,
  handleSubmit: PropTypes.func,
};

export default connect(null, null, null, { withRef: true })(
  reduxForm({
    form: "editComment",
    validate: (values) =>
      validationUtils.validate(values, FOLLOW_UP_COMMENTS_VALIDATION_RULES),
  })(FollowUpsCommentsFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/comments/FollowUpCommentsFields.js